import axios from 'axios';

// 注册账号
export const register = async (accessToken) => {
  const response = await axios.post('/api/Account/Register', {
    accessToken
  });
  return response.data;
};

// 登录
export const login = async (accessToken) => {
  const response = await axios.post('/api/Account/Login', {
    accessToken
  });
  return response.data;
};

// 登出
export const logout = async () => {
  const response = await axios.post('/api/Account/Logout');
  return response.data;
};

// 禁用/启用账号
export const setValid = async (accountId, isValid) => {
  const response = await axios.post('/api/Account/Valid', {
    accountId,
    isValid
  });
  return response.data;
};

// (DEBUG)设置账号为管理员
export const setAdmin = async (accountId, isAdmin) => {
  const response = await axios.post('/api/Account/SetAdmin', {
    accountId,
    isAdmin
  });
  return response.data;
};

// 取得使用者列表
export const getList = async () => {
  const response = await axios.get('/api/Account/GetList');
  return response.data;
}; 